<template>
    <ViewLivraison/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
import ViewLivraison from "@/components/GesCom/Livraison/ViewLivraison.vue";

    export default defineComponent({
      name: "ViewLivraisonPage",
      components: {
        
        ViewLivraison,
      },
    });
  </script>